export default {
  Warnings: {
    warning_farm_disabled: {
      manager_farms: 'Gerenciar fazendas',
      message_farm_disabled:
        'Essa fazenda está desabilitada, você não poderá editar ou criar nada. Habilite para utilizar',
    },
  },
}
